<template>
  <el-card shadow="never">
    <div>
      <el-form class="ec-line020-021-022__form-contact">
        <template v-if="!isLogin">
          <el-form-item :label="$t('common.memberInformation.fullName')" required>
            <el-row :gutter="16" type="flex">
              <el-col :span="12">
                <disabled-input :value="data.name01" />
              </el-col>
              <el-col :span="12">
                <disabled-input :value="data.name02" />
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item :label="$t('common.memberInformation.nameKana')" required>
            <el-row :gutter="16" type="flex">
              <el-col :span="12">
                <disabled-input :value="data.kana01" />
              </el-col>
              <el-col :span="12">
                <disabled-input :value="data.kana02" />
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item :label="$t('common.memberInformation.email')" required>
            <disabled-input :value="data.email" />
          </el-form-item>

          <el-form-item :label="$t('common.memberInformation.emailConfirm')" required>
            <disabled-input :value="data.email_confirm" />
          </el-form-item>

          <el-form-item :label="$t('common.memberInformation.phoneNumber')" required>
            <div class="lg:w-36">
              <el-input type="text" :value="data.phone_number" disabled></el-input>
            </div>
          </el-form-item>
        </template>

        <el-form-item :label="$t('ec-lineQA.form.contactCategory')" required>
          <el-input type="text" :value="findTextById(data.contact_category)" disabled></el-input>
        </el-form-item>

        <el-form-item :label="$t('ec-lineQA.form.contentsOfInquiry')" required>
          <disabled-input :value="data.contents" />
        </el-form-item>
      </el-form>
      <div class="flex flex-col items-center justify-center mt-10">
        <el-button class="submit-btn" @click="submit">
          {{ $t('ec-lineQA.form.step2SubmitBtn') }}
        </el-button>
        <el-button class="cancel-btn mt-8 lg:mx-2" @click="onCancel">{{ $t('common.action.cancel') }}</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import DisabledInput from '@/components/DisabledInput.vue'

export default {
  props: {
    data: { type: Object, default: () => {} },
  },

  components: {
    DisabledInput,
  },

  computed: {
    isLogin() {
      return this.$store.getters[`auth/isLogin`]
    },
    inqueryCategory() {
      return this.$store.state.master.inquiryCategory
    },
  },
  methods: {
    findTextById() {
      return this.inqueryCategory.find((i) => i.id === this.data.inquiry_category_id)?.name || ''
    },
    submit() {
      this.$emit('submit')
    },
    onCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
